import * as React from 'react'
import {useTranslation} from 'react-i18next'
import '../css/gdpr.css'
import {setTitleFont, tagger} from '../util/util'
import {useEffect} from 'react'

const TermsUse = () => {
    const {t, i18n} = useTranslation('termsUse')
    const activator = (e: any) => e.currentTarget.parentElement.lastChild.classList.toggle('active')

    useEffect(() => {
        setTitleFont(i18n.language)
    }, [])

    return (
        <div className="common-pages-container">
            <p className="title muli text-center">{t('terms of use')}</p>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('binding effect')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg"/>
                </div>
                <div className="accordion-content">
                    <p className="text">{t('this is a b')}</p>
                    <p className="text">{t('you agree that')}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('virtual currency')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg"/>
                </div>
                <div className="accordion-content">
                    <p className="text">{t('the virtual curr')}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('grant of license')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg"/>
                </div>
                <div className="accordion-content">
                    <p className="text">{t('you are granted')}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('privacy policy')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg"/>
                </div>
                <div className="accordion-content">
                    <p className="text">{tagger(t('personaly respects'), '', '/privacy_policy') }</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('fees')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg"/>
                </div>
                <div className="accordion-content">
                    <p className="text">{t('some products')}</p>
                    <p className="text">{t('your right to')}</p>
                    <p className="text">{t('it is your r')}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('alleged violations')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg"/>
                </div>
                <div className="accordion-content">
                    <p className="text">{t('company reserves the')}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('no warranties')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg"/>
                </div>
                <div className="accordion-content">
                    <p className="text">{t('company hereby d')}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('limitation of liability')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg"/>
                </div>
                <div className="accordion-content">
                    <p className="text">{t('each and every')}</p>
                    <p className="text">{t('the liability and')}</p>
                    <p className="text">{t('personaly does n')}</p>
                    <p className="text">{t('the user hereby r')}</p>
                    <p className="text">{t('however it is h')}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('affiliated sites')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg"/>
                </div>
                <div className="accordion-content">
                    <p className="text">{t('company has no')}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('prohibited uses')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg"/>
                </div>
                <div className="accordion-content">
                    <p className="text">{t('company imposes c')}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('indemnity')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg"/>
                </div>
                <div className="accordion-content">
                    <p className="text">{t('you agree to i')}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('copyright')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg"/>
                </div>
                <div className="accordion-content">
                    <p className="text">{t('all contents of')}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('severability waiver')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg"/>
                </div>
                <div className="accordion-content">
                    <p className="text">{t('if for whatever reason')}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('no license')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg"/>
                </div>
                <div className="accordion-content">
                    <p className="text">{t('nothing contained o')}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('modifications')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg"/>
                </div>
                <div className="accordion-content">
                    <p className="text">{t('company may in i')}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('acknowledgements')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg"/>
                </div>
                <div className="accordion-content">
                    <p className="text">{t('by using the service')}</p>
                </div>
            </div>
        </div>
    )
}

export default TermsUse


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/pages/termsUse.tsx